export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/FR-c2b729d671482dec082145f7e2e6139d.png";